import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import axios from 'axios';
import swal from 'sweetalert';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

const EditUser = () => {
    const history = useHistory();
    const { id } = useParams();
    const [user, setUser] = useState({
        name: "",
        email: "",
        password: "",
        error_list: [],
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/api/superadmin-editorganiser/${id}`).then(res => {
            if (res.data.status === 200) {
                setUser({
                    ...res.data.user,
                    password: "", // Don't pre-fill password for security
                    error_list: []
                });
            } else {
                swal('Error', res.data.message, 'error');
                history.push('/master/user');
            }
            setLoading(false);
        }).catch(error => {
            console.error("Error fetching user:", error);
            setLoading(false);
        });
    }, [id, history]);

    const handleInput = (e) => {
        e.persist();
        setUser({...user, [e.target.name]: e.target.value});
    };

    const updateUser = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = {
            name: user.name,
            email: user.email,
            password: user.password || undefined, // Only send password if changed
        };

        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.put(`/api/superadmin-updateorganiser/${id}`, data).then(res => {
                if (res.data.status === 200) {
                    swal('Success', "User Updated Successfully!", 'success');
                    history.push('/master/user');
                } else {
                    setUser({...user, error_list: res.data.validate_error || []});
                }
                setLoading(false);
            }).catch(error => {
                console.error("Update error:", error);
                setLoading(false);
            });
        });
    };

    if (loading) {
        return <Typography>Loading user data...</Typography>;
    }

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        component={Link}
                        to="/master/user">
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Edit User
                        </Typography>
                        <Box component="form" onSubmit={updateUser} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        id="name"
                                        label="Full Name"
                                        autoFocus
                                        name='name'
                                        onChange={handleInput} 
                                        value={user.name}
                                        error={!!user.error_list.name}
                                        helperText={user.error_list.name} />
                                </Grid> 

                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        name='email' 
                                        onChange={handleInput} 
                                        value={user.email}
                                        error={!!user.error_list.email}
                                        helperText={user.error_list.email} />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="New Password (leave blank to keep current)"
                                        type="password"
                                        id="password"
                                        name='password' 
                                        onChange={handleInput} 
                                        value={user.password}
                                        error={!!user.error_list.password}
                                        helperText={user.error_list.password} />
                                </Grid>
                            </Grid>
                           
                            <Grid container justifyContent="flex-end">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={loading}
                                    sx={{ mt: 3, mb: 2 }} >
                                    {loading ? 'Updating...' : 'Update User'}
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}

export default EditUser;